module.exports = __webpack_public_path__ + "img/icon-account-email-green@3x.df1d7828.png";